import { postUserInfo } from "@/api/user";
import { GLOBAL_KEYS } from "@/configs";
import { getCookieValue } from "@/utils";
// import { getCookieValue } from "@/utils";
import { createContext, useContext, useState } from "react";

type IUserContextProps = {
  userInfo: any;
  setUserInfo: any;
  freshUserInfo: () => Promise<boolean>;
};

export const UerInfoContext = createContext<IUserContextProps>({} as IUserContextProps);

export const UserInfoProvider = ({ children }: { children: React.ReactNode }) => {
  const [userInfo, setUserInfo] = useState<any>(null);

  const freshUserInfo = async () => {
    const token = getCookieValue(GLOBAL_KEYS.USER_TOKEN) || localStorage.getItem(GLOBAL_KEYS.USER_TOKEN);
    if (!token) {
      return false;
    }
    let status = false;
    try {
      const res = await postUserInfo<RequestResponse>();
      if (res.success) {
        setUserInfo(res.data);
        status = true;
      }
    } catch (error) {
      console.error(error);
    }
    return status;
  };

  return <UerInfoContext.Provider value={{ userInfo, setUserInfo, freshUserInfo }}>{children}</UerInfoContext.Provider>;
};

export const useUserInfo = () => {
  const context = useContext(UerInfoContext);
  if (!context) {
    throw new Error("useUserInfo must be used within a UserInfoProvider");
  }
  return context;
};
